module.exports = __webpack_public_path__ + "media/images/emblems/Zoug-ville-blason-e480804079b6bf76f673939843c770c0.svg";